module.exports = __webpack_public_path__ + "img/china.27dbceac.svg";